import { cn } from "@/lib/utils";
import { siteConfig } from "@/lib/site-config";
import type { RestaurantSiteConfig } from "@/lib/restaurant-platform";

// Fall back to an address-based embed of the canonical site config so a caller
// that omits `src` always renders this restaurant, never an opaque CID listing.
const DEFAULT_GOOGLE_MAP_URL = mapEmbedUrlForAddress(siteConfig);

type GoogleMapEmbedProps = {
  className?: string;
  iframeClassName?: string;
  src?: string;
  title?: string;
};

export function mapEmbedUrlForAddress(
  siteConfig: Pick<RestaurantSiteConfig, "address">,
): string {
  const query = encodeURIComponent(
    `${siteConfig.address.line1}, ${siteConfig.address.city}, ${siteConfig.address.state} ${siteConfig.address.zip}`,
  );

  return `https://maps.google.com/maps?q=${query}&output=embed`;
}

export function GoogleMapEmbed({
  className,
  iframeClassName,
  src = DEFAULT_GOOGLE_MAP_URL,
  title = "Restaurant Google Map",
}: GoogleMapEmbedProps) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-lg border border-[var(--roma-parchment-line)] bg-[var(--roma-ivory)]",
        className,
      )}
    >
      <iframe
        src={src}
        loading="lazy"
        title={title}
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        className={cn("h-[280px] w-full border-0", iframeClassName)}
      />
    </div>
  );
}
